import { render, staticRenderFns } from "./DadosOrdem.vue?vue&type=template&id=26040d0d&scoped=true&"
import script from "./DadosOrdem.vue?vue&type=script&lang=js&"
export * from "./DadosOrdem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26040d0d",
  null
  
)

export default component.exports